import * as React from 'react';
import Box from '@mui/material/Box';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, LinearProgress,  MenuItem,  OutlinedInput,  Radio,  RadioGroup,  Select,  SelectChangeEvent,  Table,  TableBody,  TableCell,  TableRow, TextField, useMediaQuery, useTheme } from '@mui/material';
import { useGetGrupos } from '../../hooks/useGrupos';
import { useContext, useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { useGetAlumnos } from '../../hooks/getAlumnos';
import { UserContext } from '../../contexts/userContext';
import { monthToNumber, monthToString } from '../../utils/utils';
import { AddAsistenciaParams, useAddAsistencia } from '../../hooks/addAsistencia';
import { INICIO_CONTROL_PAGOS } from '../../utils/constants';
import { IndicatorButton } from '../IndicatorButton';

export default function ReporteAsistencia() {
  const { user } = useContext(UserContext);

  const [selectedMonth, setSelectedMonth] = useState<string>(monthToString(dayjs().month() + 1 ) || 'Enero');
  const [selectedYear, setSelectedYear] = useState<string>(dayjs().year().toString());

  const alumnos = useGetAlumnos(user, false, false, parseInt(selectedYear));
  const grupos = useGetGrupos(user);

  const [nuevaAsistencia, setNuevaAsistencia] = useState<AddAsistenciaParams | null>();
  const addAsistenciaApiCall = useAddAsistencia(nuevaAsistencia, user);
  const [edition, setEdition] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (addAsistenciaApiCall.data && !addAsistenciaApiCall.isLoading && edition) {
      alumnos.refetch();
    }
  }, [addAsistenciaApiCall.data]);

  useEffect(() => {
    if (alumnos.data && !alumnos.isLoading && edition) {
      setLoading(false);
      setEdition(false);
    }
  }, [alumnos.data]);

  useEffect(() => {
    alumnos.refetch();
  }, [selectedYear]);


  const [nuevaObs, setNuevaObs] = useState<string | null>(null);
  const [alumnoId, setAlumnoId] = useState<string | null>(null);
  const [value, setValue] = React.useState<Dayjs | null>(null);
  const [nuevoValor, setNuevoValor] = useState<'presente' | 'ausente' | 'sin-clases' | null>(null);

  const monthsOption = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  const currentYear = dayjs().year();
  const listingYears:(number | never)[] = [];
  for (let year = dayjs(INICIO_CONTROL_PAGOS).year(); year <= currentYear; year++) listingYears.push(year);

  const daysInMonth = dayjs(`${selectedYear}-${String(monthToNumber(selectedMonth)).padStart(2, '0')}-01`).daysInMonth();
  const daysHeader = [''];
  for (let d = 1; d <= daysInMonth; d++) daysHeader.push(d.toString());

  const [filtro, setFiltro] = useState<string | null>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (grupos.data?.length) {
      setFiltro(grupos.data[0].nombre);
    }
  }, [grupos.data]);


  if (!user?._id) return null;

  if (grupos.isLoading || !grupos.data || alumnos.isLoading || !alumnos.data || !filtro ) return <LinearProgress />;
  const alumnosDelGrupo = alumnos.data?.filter((a) => filtro?.toUpperCase() === a.grupo?.toUpperCase()) ?? [];


  return (
    <Box sx={{ height: isMobile ? 'calc(100vh - 115px)' : 'calc(100vh - 185px)', width: 1 }}>
      <Dialog
        open={edition}
        onClose={() => setEdition(false)}
      >
        <DialogTitle id="asistencia-dialog">
          {`Editar asistencia del ${dayjs(value).format('DD/MM/YYYY')}`}
        </DialogTitle>
        <DialogContent>
          <RadioGroup
            value={nuevoValor}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNuevoValor((event.target as HTMLInputElement).value as 'presente' | 'ausente' | 'sin-clases');
            }}
          >
            <FormControlLabel value="presente" control={<Radio />} label="Presente" />
            <FormControlLabel value="ausente" control={<Radio />} label="Ausente" />
            <FormControlLabel value="sin-clases" control={<Radio />} label="No tuvo clases" />
          </RadioGroup>
          <TextField
            margin="dense"
            id="obs"
            label="Observaciones"
            type="text"
            fullWidth
            variant="standard"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNuevaObs(event.target.value);
            }}
            value={nuevaObs ?? ''}
          />
        </DialogContent>
        <DialogActions>
          <IndicatorButton
            onClick={() => {
              setLoading(true);
              setNuevaAsistencia({ id: alumnoId ?? '', asistencia: nuevoValor, dia: value?.toISOString(), obs: nuevaObs ?? undefined });
            }}
            label='Guardar Cambios'
            loading={loading}
          />
          <Button
            onClick={ () => {setNuevoValor(null); setNuevaObs(null); setEdition(false);}}
            variant="outlined"
            autoFocus
            disabled={loading}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <FormControl fullWidth>
            <Select
              input={<OutlinedInput sx={{ fontSize: 18, fontWeight: 'bold' }}/>}
              id="selector-grupo-asistencia"
              value={filtro}
              onChange={(event: SelectChangeEvent) => setFiltro(event.target.value)}
            >
              {grupos.data.map((grupo) => (
                <MenuItem key={grupo._id} value={grupo.nombre}>{grupo.nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} md={2} >
          <FormControl fullWidth>
            <Select
              input={<OutlinedInput sx={{ fontSize: 18, fontWeight: 'bold' }}/>}
              id="selector-mes"
              value={selectedMonth}
              onChange={(event: SelectChangeEvent) => setSelectedMonth(event.target.value)}
            >
              {monthsOption.map((month) => (
                <MenuItem key={`option-${month}`} value={month}>{month}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} md={2} >
          <FormControl fullWidth>
            <Select
              input={<OutlinedInput sx={{ fontSize: 18, fontWeight: 'bold' }}/>}
              id="selector-anio"
              value={selectedYear}
              onChange={(event: SelectChangeEvent) => setSelectedYear(event.target.value)}
            >
              {listingYears.map((year) => (
                <MenuItem key={`option-${year}`} value={year}>{year}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Table style={{
        minWidth: 650,
        marginTop: 16,
        marginBottom: 16,
      }} aria-label="simple table" >
        <TableBody style={{
          borderBottomWidth: 1.8,
          borderRightWidth: 1.8,
          borderBottomStyle: 'solid',
          borderRightStyle: 'solid',
        }}>
          <TableRow key="days"style={{ width: 30 }} >
            {daysHeader?.map((day) => (
              <TableCell
                key={`${day}-table-header`}
                style={{ borderStyle: 'solid', borderColor: 'black', borderBottomWidth: 1.8, padding: 3, height: 30, width: 30, textAlign: 'center' }}
              >
                {day}
              </TableCell>
            ))}
          </TableRow>
          {alumnosDelGrupo?.sort((a, b) => {
            if (a.apellido.toLowerCase() < b.apellido.toLowerCase())  return -1;
            if (a.apellido.toLowerCase() > b.apellido.toLowerCase()) return 1;
            return 0;
          }).map((alumno) => (
            <TableRow
              key={`${alumno.dni}-table-header`}
              style={{ backgroundColor: 'white' }}
            >
              <TableCell style={{ borderStyle: 'solid', padding: 3, height: 30, whiteSpace: 'nowrap' }}>{`${alumno.apellido} ${alumno.name}`}</TableCell>
              {daysHeader.filter((d) => !!d).map((dia) => {
                const diaCelda = dayjs(`${selectedYear}-${String(monthToNumber(selectedMonth)).padStart(2, '0')}-${String(dia).padStart(2, '0')}`);
                const asistencia = alumno.asistencia.find((a) => diaCelda.isSame(a.dia, 'day'));
                let color = 'rgb(220 220 220)';
                if (asistencia?.asistencia === true) color = '#419b22';
                if (asistencia?.asistencia === false) color = '#cc393a';
                return (
                  <TableCell
                    onClick={() => {
                      setValue(diaCelda);
                      setAlumnoId(alumno._id);
                      setEdition(true);
                    }}
                    key={`table-cell-${alumno.name}-${dia}`}
                    style={{ padding: 2, borderColor: 'white', height: 30, width: 30 }}>
                    <div style={{
                      backgroundColor: color,
                      height: '100%',
                      width: '100%',
                      borderRadius: 4,
                    }}/>
                  </TableCell>
                );
              },
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
